module.exports = __webpack_public_path__ + "static/media/tummy_time.e0817bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/tummy_time.png
// module id = 1484
// module chunks = 31